module.exports = __webpack_public_path__ + "static/img/tabela.dcef133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja/tabela.png
// module id = g/JT
// module chunks = 0